const OPEN_POSTING_STATE_STORAGE_KEY = 'weeklyGLPosting.openPostingState';
const OPEN_POSTING_RESTORE_INTENT_STORAGE_KEY = 'weeklyGLPosting.openPostingRestoreIntent';
const OPEN_POSTING_RESTORE_INTENT_MAX_AGE_MS = 15 * 60 * 1000;

const getSessionStorage = () => {
  if (typeof window === 'undefined') return null;
  return window.sessionStorage;
};

export const readOpenPostingState = () => {
  const storage = getSessionStorage();
  if (!storage) return {};

  const rawState = storage.getItem(OPEN_POSTING_STATE_STORAGE_KEY);
  if (!rawState) return {};

  try {
    const parsedState = JSON.parse(rawState);
    if (!parsedState || typeof parsedState !== 'object' || Array.isArray(parsedState)) return {};
    return parsedState;
  } catch (error) {
    return {};
  }
};

export const writeOpenPostingState = (nextStatePatch = {}) => {
  const storage = getSessionStorage();
  if (!storage) return;
  if (!nextStatePatch || typeof nextStatePatch !== 'object' || Array.isArray(nextStatePatch)) return;

  const currentState = readOpenPostingState();
  const nextState = {
    ...currentState,
    ...nextStatePatch,
  };

  storage.setItem(OPEN_POSTING_STATE_STORAGE_KEY, JSON.stringify(nextState));
};

export const clearOpenPostingState = () => {
  const storage = getSessionStorage();
  if (!storage) return;
  storage.removeItem(OPEN_POSTING_STATE_STORAGE_KEY);
};

export const setOpenPostingRestoreIntent = () => {
  const storage = getSessionStorage();
  if (!storage) return;
  storage.setItem(OPEN_POSTING_RESTORE_INTENT_STORAGE_KEY, String(Date.now()));
};

export const isOpenPostingRestoreIntentActive = () => {
  const storage = getSessionStorage();
  if (!storage) return false;
  const rawIntentTimestamp = storage.getItem(OPEN_POSTING_RESTORE_INTENT_STORAGE_KEY);
  if (!rawIntentTimestamp) return false;

  const parsedTimestamp = Number(rawIntentTimestamp);
  if (!Number.isFinite(parsedTimestamp) || parsedTimestamp <= 0) return false;

  return Date.now() - parsedTimestamp <= OPEN_POSTING_RESTORE_INTENT_MAX_AGE_MS;
};

export const clearOpenPostingRestoreIntent = () => {
  const storage = getSessionStorage();
  if (!storage) return;
  storage.removeItem(OPEN_POSTING_RESTORE_INTENT_STORAGE_KEY);
};
